module.exports = __webpack_public_path__ + "img/icon_sm_kccx.4910f0e9.png";